import { buildQueryString } from '../helpers/Utils';

export default class Vehicles {
  constructor(api) {
    this.api = api;
  }

  async types() {
    return this.api.fetchJson('/api/vehicles/types');
  }

  async findById(id) {
    return this.api
      .fetch(`/api/vehicles/${id}`)
      .then(res => res.json())
      .then(json => json.data);
  }

  async info(id) {
    return new Promise((resolve, reject) => {
      this.api
        .fetch('/api/vehicles/info?id=' + id)
        .then(res => {
          res.json().then(json => resolve(json));
        })
        .catch(reason => reject(reason));
    });
  }

  async list(query) {
    query = query || {};
    const queryString = buildQueryString(query);

    return new Promise((resolve, reject) => {
      this.api
        .fetch('/api/vehicles/list' + queryString)
        .then(res => {
          if (res.ok) {
            resolve(res.json());

            return;
          }
          reject(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }

  selectData(query) {
    return new Promise((resolve, reject) => {
      this.api.fetch('/api/vehicles/selectdata').then(res => {
        res.json().then(json => {
          resolve(json.data);
        });
      });
    });
  }

  createOrUpdate(data) {
    const method = data.id ? 'PUT' : 'POST';
    return new Promise((resolve, reject) => {
      this.api
        .fetch('/api/vehicles', {
          method,
          credentials: 'include',
          body: JSON.stringify(data),
          headers: {
            Accept:
              'application/json, application/xml, text/plain, text/html, *.*',
            'Content-Type': 'application/json',
          },
        })
        .then(res => {
          resolve(res.json());
        })
        .catch(res => {
          reject(res);
        });
    });
  }
}
